module.exports = __webpack_public_path__ + "static/media/Badge_PngMarqueParcours_Skinc.4a758f12.png";